var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L49.1055728,98.2111456 C49.3525621,98.7051241 49.9532351,98.9053485 50.4472136,98.6583592 C50.640741,98.5615955 50.7976635,98.404673 50.8944272,98.2111456 L100,0 L100,100 L0,100 L0,0 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBottom);
export default __webpack_public_path__ + "static/media/header-bottom.e9f6afc68315c6d5372e0b6e770e0ff1.svg";
export { ForwardRef as ReactComponent };